/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PagedModelRequest } from './pagedModelRequest';
import { DeniedChargesViewModel } from './deniedChargesViewModel';
import { PagedListMetaData } from './pagedListMetaData';

export interface DeniedChargesViewModelPagedModelResponse {
  pagedRequest?: PagedModelRequest;
  data?: Array<DeniedChargesViewModel> | null;
  metaData?: PagedListMetaData;
}
